import React from 'react'
import cn from 'classnames'

import { ActionButton } from '../ActionButton/ActionButton'
import { TransformChange } from '../TransformChange/TransformChange'

import './CustomerForm.scss'

export const CustomerForm = ({
  lock,
  maxBid,
  minBid,
  bid,
  actionResult,
  onChange,
  onBid,
  onBuy,
  onCancel,
}) => {
  return (
    <div className={cn( 'customer-form', { lock } )}>
      <ActionButton
        label="BUY"
        green
        onClick={ onBuy }
      />
      {
        onCancel
        && (
          <ActionButton
            label="CANCEL BID"
            yellow
            onClick={ onCancel }
          />
        )
      }
      {
        onBid
        && (
          <TransformChange
            label="BID"
            checkLabel="I AGREE TO PLACE THE BID"
            max={ maxBid }
            min={ minBid }
            amount={ bid }
            actionResult={ actionResult }
            onChange={ onChange }
            onAccept={ onBid }
          />
        )
      }
    </div>
  )
}